import PropTypes from "prop-types";
import ScheduleCard from "@/pages/event_management/single_sub_event/components/sub_event_schedule_tabs/Schedule_Card";
import { useParams } from "react-router-dom";

const ScheduleTab = ({ schedules, onScheduleSuccess, onScheduleError }) => {
  const { id } = useParams();

  // If schedules is an array of schedule objects
  if (Array.isArray(schedules) && schedules.length > 0) {
    return (
      <div className="mt-4">
        {schedules.map((schedule, index) => (
          <ScheduleCard
            key={schedule._id || schedule.id || `schedule-${index}`}
            schedule={schedule}
            subEventId={id}
            onScheduleSuccess={onScheduleSuccess}
            onScheduleError={onScheduleError}
          />
        ))}
      </div>
    );
  }

  // If there are no schedules or it's an empty array
  return (
    <div className="mt-4 text-center p-6 bg-gray-50 rounded-md">
      <p className="text-gray-500">
        No schedules available. Click &quot;Add More&quot; to create a schedule.
      </p>
    </div>
  );
};

ScheduleTab.propTypes = {
  schedules: PropTypes.array,
  onScheduleSuccess: PropTypes.func,
  onScheduleError: PropTypes.func,
};

export default ScheduleTab;
